import { GenomicFeatureTypeEnum, SequencingTypeEnum, SyntenyTypeEnum, TrackEnum } from "../openapi.ts";
import { URL_ENTITY_TYPES } from "../settings.ts";
import type { TrackType, UrlEntityType } from "../types.ts";

const EntityTypeToGenomicFeatureTypeMap: Partial<Record<UrlEntityType, GenomicFeatureTypeEnum>> = {
  [URL_ENTITY_TYPES.PROTEIN]: GenomicFeatureTypeEnum.PROTEIN,
  [URL_ENTITY_TYPES.GENE]: GenomicFeatureTypeEnum.GENE,
  [URL_ENTITY_TYPES.PROTEIN_LOCATION]: GenomicFeatureTypeEnum.PROTEIN_LOCATION,
  [URL_ENTITY_TYPES.NUFEATURE]: GenomicFeatureTypeEnum.NUCLEOTIDE_FEATURE,
};

const GenomicTypeToTrackTypeMap: Partial<Record<GenomicFeatureTypeEnum, TrackType>> = {
  GENE: TrackEnum.GENE,
  PROTEIN: TrackEnum.PROTEIN_LOCATION,
  PROTEIN_LOCATION: TrackEnum.PROTEIN_LOCATION,
  NUCLEOTIDE_FEATURE: TrackEnum.NUCLEOTIDE_FEATURE,
};

const TrackTypeToGenomicTypeMap: Partial<Record<TrackType, GenomicFeatureTypeEnum>> = {
  [TrackEnum.GENE]: GenomicFeatureTypeEnum.GENE,
  [TrackEnum.PROTEIN_LOCATION]: GenomicFeatureTypeEnum.PROTEIN_LOCATION,
  [TrackEnum.NUCLEOTIDE_FEATURE]: GenomicFeatureTypeEnum.NUCLEOTIDE_FEATURE,
};

const TrackTypeToEntityTypeMap: Partial<Record<TrackType, string>> = {
  [TrackEnum.GENE]: URL_ENTITY_TYPES.GENE,
  [TrackEnum.TRANSCRIPT_LOCATION]: URL_ENTITY_TYPES.TRANSCRIPT,
  [TrackEnum.PROTEIN_LOCATION]: URL_ENTITY_TYPES.PROTEIN,
  [TrackEnum.SEQUENCE]: URL_ENTITY_TYPES.SEQUENCE,
  [TrackEnum.NUCLEOTIDE_FEATURE]: URL_ENTITY_TYPES.NUFEATURE,
  [TrackEnum.AA_SEQUENCE_FEATURE]: URL_ENTITY_TYPES.AAFEATURE,
};

export function getGenomicFeatureTypeFromEntity(entityType: UrlEntityType): GenomicFeatureTypeEnum {
  return EntityTypeToGenomicFeatureTypeMap[entityType] ?? GenomicFeatureTypeEnum.PROTEIN;
}

export function getTrackTypeFromGenomicFeatureType(entityType: GenomicFeatureTypeEnum): TrackType {
  return GenomicTypeToTrackTypeMap[entityType] ?? TrackEnum.PROTEIN_LOCATION;
}

export function getGenomicFeatureTypeFromTrackType(trackType: TrackType): GenomicFeatureTypeEnum {
  return TrackTypeToGenomicTypeMap[trackType] ?? GenomicFeatureTypeEnum.PROTEIN_LOCATION;
}

export function getEntityTypeFromTrackType(trackType: TrackType): UrlEntityType {
  return (TrackTypeToEntityTypeMap[trackType] as UrlEntityType) ?? URL_ENTITY_TYPES.PROTEIN_LOCATION;
}

export const getTrackTypeBySyntenyType = (syntenyType: SyntenyTypeEnum) => {
  if (syntenyType === SyntenyTypeEnum.PROTEIN) {
    return TrackEnum.PROTEIN_LOCATION;
  } else if (syntenyType === SyntenyTypeEnum.GENE) {
    return TrackEnum.GENE;
  } else if (syntenyType === SyntenyTypeEnum.GENOME_ALIGNMENT) {
    return TrackEnum.SEQUENCE;
  }
  return TrackEnum.PROTEIN_LOCATION;
};

export const getSyntenyTypeBySequencingType = (sequencingType: SequencingTypeEnum) => {
  if (sequencingType === SequencingTypeEnum.PROTEIN_SYNTENY) {
    return SyntenyTypeEnum.PROTEIN;
  } else if (sequencingType === SequencingTypeEnum.GENE_SYNTENY) {
    return SyntenyTypeEnum.GENE;
  } else if (sequencingType === SequencingTypeEnum.PANGENOME) {
    return SyntenyTypeEnum.GENOME_ALIGNMENT;
  }

  return SyntenyTypeEnum.PROTEIN;
};

export const getTrackTypeBySequencingType = (sequencingType: SequencingTypeEnum) => {
  if (sequencingType === SequencingTypeEnum.PROTEIN_SYNTENY) {
    return TrackEnum.PROTEIN_LOCATION;
  } else if (sequencingType === SequencingTypeEnum.GENE_SYNTENY) {
    return TrackEnum.GENE;
  } else if (sequencingType === SequencingTypeEnum.PANGENOME) {
    return TrackEnum.SEQUENCE;
  }

  return TrackEnum.PROTEIN_LOCATION;
};
